// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1i-o";
export var animationRelative = "_1i-n";
export var backdropBlur = "_1i-0";
export var detailLabelCell = "_1i-10";
export var detailTable = "_1i-z";
export var detailValueCell = "_1i-11";
export var docIconBox = "_1i-19";
export var docTypeRow = "_1i-14";
export var docTypeRowInner = "_1i-15";
export var dropdownMatchDatePicker = "_1i-1";
export var fileUploadSpin = "_1i-h";
export var gorgiasOpenButton = "_1i-13 _1i-b";
export var gorgiasTicketCard = "_1i-12";
export var heroModalFooterButton = "_1i-16";
export var hiddenContainer = "_1i-m";
export var maxWidthContainer = "_1i-17";
export var modalContentBody = "_1i-8";
export var modalHeaderImage = "_1i-3";
export var modalImageLabel = "_1i-5";
export var modalImageOverlay = "_1i-4";
export var modalImageSubtitle = "_1i-7";
export var modalImageTitle = "_1i-6";
export var modalImageWrapper = "_1i-2";
export var modalStickyFooter = "_1i-9";
export var removeButton = "_1i-c";
export var sidebarColumn = "_1i-18";
export var spinner = "_1i-g";
export var timelineLine = "_1i-w";
export var timelineLineBlack = "_1i-y _1i-w";
export var timelineLineGray = "_1i-x _1i-w";
export var timelineLineHeight = "_1i-v";
export var tlDotActivate = "_1i-s";
export var tlDotActivateAnim = "_1i-r";
export var tlDotHide = "_1i-q";
export var tlDotHideAnim = "_1i-p";
export var tlLineActivate = "_1i-u";
export var tlLineActivateAnim = "_1i-t";
export var uploadHint = "_1i-l";
export var uploadIconBox = "_1i-i";
export var uploadLabel = "_1i-k";
export var uploadText = "_1i-j";
export var uploadZone = "_1i-d";
export var uploadZoneCursorDefault = "_1i-f";
export var uploadZoneCursorPointer = "_1i-e";
export var uploadedFileRow = "_1i-a";
export var viewButton = "_1i-b";